package one.healthium.insights.ui.insights.models

import one.healthium.loco.LString

data class EmptyUiModel(
    val title: LString,
    val message: LString,
)
